<template>
  <div id="app">
    <div>
      <y-sidebar
        v-if="isAuthenticated"
        :isMovil="isMovil"
        :isVisible="isVisible"
        @select="activar"
      />
      <div
        class="home"
        :class="{ 'home-full': !isAuthenticated, open: !isOculto }"
      >
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
      <div
        v-if="isAuthenticated"
        class="overlay"
        id="overlay"
        v-on:click="ocultarSide()"
      ></div>
    </div>
    <div
      class="pageloader"
      style="z-index: 90 !important;"
      v-bind:class="{ 'is-active': loading }"
    >
      <span class="title"></span>
    </div>
    <div
      class="preloader"
      style="z-index: 1900 !important;"
      v-bind:class="{ 'is-active': loading1 }"
      v-bind:style="styleObjectloading"
    >
      <img src="@/assets/loadingcincel.svg" />
    </div>
    <y-modal></y-modal>
    <y-modalinforme></y-modalinforme>
    <y-modalnotification></y-modalnotification>
    <y-modalordengraph></y-modalordengraph>
  </div>
</template>

<script>
import ySidebar from "@/components/core/Sidebar.vue";
import yModal from "@/components/modals/Modal.vue";
import { mapState } from "vuex";
import yModalinforme from "@/components/modals/Modalinforme.vue";
import yModalnotification from "@/components/modals/Modalnotification.vue";
import yModalordengraph from "@/components/modals/Modalordengraph.vue";

export default {
  name: "app",
  data() {
    return {
      menu: [],
      isVisible: true,
      isMovil: false,
      fullwidth: false,
      width: null,
    };
  },
  computed: {
    ...mapState([
      "isAuthenticated",
      "user",
      "empresa",
      "loading",
      "loading1",
      "isOculto",
      "tokenUser",
    ]),
    styleObject() {
      let d = {};
      if (this.isAuthenticated) {
        if (this.isMovil) {
          d["margin-left"] = 0;
          d["transition"] = "0.3s all ease";
        } else {
          if (this.isOculto) {
            d["margin-left"] = "196px";
            d["transition"] = "0.3s all ease";
          } else {
            d["margin-left"] = 0;
            d["transition"] = "0.3s all ease";
          }
        }
      } else {
        d["margin-left"] = 0;
        d["transition"] = "0.3s all ease";
      }
      return d;
    },
    styleObjectloading() {
      let d = {};
      if (this.isAuthenticated) {
        if (this.isMovil) {
          d["margin-left"] = "60px";
          d["width"] = this.width + "px";
        } else {
          if (!this.isOculto) {
            d["margin-left"] = "250px";
            d["width"] = this.width - 196 + "px";
          } else {
            d["margin-left"] = "60px";
            d["width"] = this.width + "px";
          }
        }
      } else {
        d["margin-left"] = 0;
        d["width"] = this.width + "px";
      }
      return d;
    },
    styleButtonFloat() {
      let d = {};
      if (this.isOculto) {
        d["margin-left"] = "214px";
        d["transition"] = "0.3s all ease";
      } else {
        d["margin-left"] = "14px";
        d["transition"] = "0.3s all ease";
      }
      return d;
    },
  },
  methods: {
    functionWidth(n) {
      const w = window.innerWidth;
      const h = window.innerHeight;
      this.width = w;
      this.$store.commit("changeheight", h);
      this.$store.commit("changewidth", w);
      if (w < 769) {
        n.isMovil = true;
        this.$store.commit("changemovil", true);
      } else {
        n.isMovil = false;
        this.$store.commit("changemovil", false);
      }
    },
    activar: function(a) {
      if (a.mostrar) {
        a.mostrar = false;
      } else {
        a.mostrar = true;
      }
      a.active = true;
      this.menu.forEach(function(k) {
        k.menus.forEach(function(k1) {
          if (a !== k1) {
            k1.active = false;
          }
          if (k1.subcategorias) {
            k1.subcategorias.forEach(function(k2) {
              if (a !== k2) {
                k2.active = false;
              }
            });
          }
        });
      });
    },
    mostrarBurger: function() {
      if (this.isVisible) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    },
    ocultarSide() {
      this.$store.commit("ocultarSide");
    },
    myEventHandler(e) {
      this.functionWidth(this);
    },
  },
  mounted: function() {
    this.muestraMenu = true;
    this.functionWidth(this);
  },
  async created() {
    window.addEventListener("resize", this.myEventHandler);
    if (this.$store.state.isLogged) {
      this.$store.dispatch("refreshAuth");
    }
  },
  destroyed: function() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  components: {
    // yFooter,
    ySidebar,
    yModal,
    yModalinforme,
    yModalnotification,
    yModalordengraph,
  },
};
</script>

<style lang="scss">
@import "./scss/main.scss";

@media print {
  @page {
    size: letter;
  }
  .columns .is-12 .graphic {
    page-break-after: always !important;
    margin-top: 10% !important;
    margin-bottom: 50% !important;
  }
  div {
    page-break-inside: avoid !important;
  }

  .contenct-dash {
    margin-left: 0px !important;
    margin: auto !important;
  }
  .btn-print {
    display: none !important;
  }
  body {
    max-height: 100% !important;
    max-width: 100% !important;
    zoom: 0.33 !important;
    -moz-transform: scale(0.33);
    -moz-transform-origin: 0 0;
    display: block;
  }
  .ybuttonFloat {
    display: none !important;
  }
  .pageloader {
    display: none !important;
  }
  .table-container-none {
    display: block !important;
  }
  .graph-none {
    display: none !important;
  }
}

.btn-print {
  top: 70%;
  right: 20px;
  position: fixed;
  z-index: 30;
  box-shadow: 5px 0px 13px 3px;
  border-radius: 50%;
  background-color: #905fbf !important;
}

/* ========== Config Sidebar ========== */

:root {
  /* ===== Colors ===== */
  --body-color: #e4e9f7;
  --sidebar-color: #510087; // #8740cd
  --primary-color: #d27ff9;
  --primary-color-light: #f6f5ff;
  --toggle-color: #ddd;
  --text-color: #ffffff;

  --sb-track-color: #510087;
  --sb-thumb-color: #fff;
  --sb-size: 5px;

  /* ====== Transition ====== */
  --tran-03: all 0.2s ease;
  --tran-03: all 0.3s ease;
  --tran-04: all 0.3s ease;
  --tran-05: all 0.3s ease;
}

.home {
  position: absolute;
  top: 0;
  left: 250px;
  height: 100vh;
  width: calc(100% - 250px);
  transition: all 0.3s ease;
  @media (max-width: 768px) {
    width: calc(100% - 76px);
    left: 68px;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease-in-out;
}

@media (min-width: 768px) {
  /* Overlay (solo en móviles) */
  .overlay {
    visibility: hidden !important;
    opacity: 0 !important;
  }
}

.sidebar.close ~ .home {
  left: 68px;
  height: 100vh;
  width: calc(100% - 76px);
}

.sidebar.close ~ .overlay {
  visibility: hidden;
  opacity: 0;
}

.home-full {
  left: 0 !important;
  width: 100% !important;
}

/* ====== ================ ====== */

.ybuttonFloat {
  top: 10px;
  position: fixed;
  z-index: 31;
  margin-left: 214px;
  box-shadow: 5px 0px 13px 3px rgba(0, 0, 0, 0.1);
}

.preloader {
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  display: none;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  z-index: 29;
}

.preloader.is-active {
  display: flex;
}

.column {
  margin-bottom: auto !important;
}

// Estilos del Tooltip
.tooltip {
  display: block !important;
  z-index: 56;
}

.tooltip .tooltip-inner {
  background: rgba(0, 0, 0, 0.62);
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: rgba(0, 0, 0, 0.62);
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: rgba(0, 0, 0, 0.62);
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.62);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

//ESTILOS JUSTIFY

.is-justify-end {
  justify-content: end !important;
}

.is-justify-start {
  justify-content: start !important;
}

.is-justify-center {
  justify-content: center !important;
}

.is-justify-between {
  justify-content: space-between !important;
}

// ESTILO PARA TABLA CON SCROLLBAR SUPERIOR Y LA ULTIMA COLUMNA FIJA

.stick-colum {
  position: sticky;
  right: 0;
  background-color: white;
}

.scroll-top {
  overflow-x: auto;
  transform: rotateX(180deg);
}

.scroll-top::-webkit-scrollbar {
  -webkit-appearance: none;
}

.scroll-top::-webkit-scrollbar:vertical {
  width: 10px;
}

.scroll-top::-webkit-scrollbar-button:increment,
.scroll-top::-webkit-scrollbar-button {
  display: none;
}

.scroll-top::-webkit-scrollbar:horizontal {
  height: 10px;
}

.scroll-top::-webkit-scrollbar-thumb {
  background-color: #a19f9f;
  border-radius: 20px;
  border: 2px solid #f1f2f3;
}

.scroll-top::-webkit-scrollbar-track {
  border-radius: 10px;
}

// SCROLL LIGHT
.scroll-light::-webkit-scrollbar {
  -webkit-appearance: none;
}

.scroll-light::-webkit-scrollbar:vertical {
  width: 10px;
}

.scroll-light::-webkit-scrollbar-button:increment,
.scroll-light::-webkit-scrollbar-button {
  display: none;
}

.scroll-light::-webkit-scrollbar:horizontal {
  height: 10px;
}

.scroll-light::-webkit-scrollbar-thumb {
  background-color: #a19f9f;
  border-radius: 20px;
  border: 2px solid #f1f2f3;
}

.scroll-light::-webkit-scrollbar-track {
  border-radius: 10px;
}

// SE MODIFICA EL Z-INDEX DEL MODAL
.modal {
  z-index: 200 !important;
}

// CAMBIO DE COLORES AL MULTI-SELECT
.multiselect__spinner:after,
.multiselect__spinner:before {
  border-top-color: #510087 !important;
}
.multiselect__tag {
  background: #510087 !important;
}

.multiselect__option--highlight {
  background: #510087 !important;
}
.multiselect__option--highlight:after {
  background: #510087 !important;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a !important;
}

.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ff6a6a !important;
}
.multiselect__option--group-selected.multiselect__option--highlight {
  background: #ff6a6a !important;
}
.multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #ff6a6a !important;
}

.is-grey-ligth {
  background-color: #f5f5f5 !important;
  color: #510087 !important;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/App.vue